import { isDeepEqual } from 'sections/utils/objectDeepEqual';
import { uuid } from 'utils';

export interface SplitTestDto {
  splitTestId: string;
  splitTestname?: string;
  scheduling: {
    startDate: Date;
    startTime: string;
    endDate?: Date;
    endTime?: string;
  };
  variantTemplateIds?: string[];
}

export class SplitTestIdGenerator {
  private static hasTemplateIdsChanged(prevVariantTemplateIds: string[], currVariantTemplateIds: string[]): boolean {
    return !isDeepEqual(prevVariantTemplateIds, currVariantTemplateIds);
  }

  private static hasDateChanged(
    prevScheduling: SplitTestDto['scheduling'],
    currScheduling: SplitTestDto['scheduling'],
  ): boolean {
    return !(
      prevScheduling.startDate === currScheduling.startDate && prevScheduling.endDate === currScheduling.endDate
    );
  }

  private static hasDateExpire(prevScheduling: SplitTestDto['scheduling']): boolean {
    return prevScheduling.endDate < new Date();
  }

  public static generate(previousSplitTest: SplitTestDto, currentSplitTest: SplitTestDto): string {
    if (!previousSplitTest?.splitTestId || previousSplitTest.splitTestId !== currentSplitTest.splitTestId) {
      return currentSplitTest?.splitTestId || uuid();
    }

    if (
      SplitTestIdGenerator.hasDateChanged(previousSplitTest.scheduling, currentSplitTest.scheduling) &&
      SplitTestIdGenerator.hasDateExpire(previousSplitTest.scheduling)
    ) {
      return uuid();
    }

    if (
      SplitTestIdGenerator.hasTemplateIdsChanged(
        previousSplitTest.variantTemplateIds,
        currentSplitTest.variantTemplateIds,
      )
    ) {
      return uuid();
    }

    return currentSplitTest.splitTestId;
  }
}
